function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.3894 9.60241L9.82096 9.93976V11.753H6.80399V9.89759L6.23558 9.56024C4.96758 8.84337 4.18055 7.53614 4.18055 6.10241C4.18055 3.90964 6.01696 2.09639 8.33434 2.09639C10.6517 2.09639 12.4881 3.86747 12.4881 6.10241C12.4444 7.57831 11.6574 8.88554 10.3894 9.60241ZM8.29061 1C5.3611 1 3 3.27711 3 6.10241C3 8 4.04938 9.64458 5.66717 10.5301V12.3434C5.66717 12.6386 5.88579 12.8494 6.19186 12.8494H10.4768C10.7829 12.8494 11.0015 12.6386 11.0015 12.3434V10.5301C12.5756 9.64458 13.6687 8 13.6687 6.10241C13.625 3.27711 11.2201 1 8.29061 1ZM10.2582 13.8614H6.36675C6.27931 13.8614 6.23558 13.9036 6.23558 13.988V14.494C6.23558 14.7892 6.4542 15 6.76027 15H9.86468C10.1707 15 10.3894 14.7892 10.3894 14.494V13.988C10.3894 13.9036 10.3019 13.8614 10.2582 13.8614Z",
  fill: "currentcolor"
});

const SvgLearn = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLearn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/learn.1e380fdc.svg";
export { ForwardRef as ReactComponent };